import { UNIDADES } from "@caint/data";
import { Header } from "@caint/design-system";
import { Fragment } from "react";
import {
  RelatorioExecutivo,
  type RelatorioExecutivoProps,
} from "../components/relatorio/RelatorioExecutivo.tsx";

export type RelatorioProps = RelatorioExecutivoProps;

export function Relatorio(props: RelatorioProps) {
  const ativa = UNIDADES.find((u) => u.id === props.avaliacaoAtual?.unidadeId);
  return (
    <Fragment>
      <Header title="Relatório Executivo" sub={ativa?.nome ?? "Unidade"} />
      <div className="m-body">
        <div className="no-print" style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
          <button type="button" className="m-btn" onClick={() => window.print()}>
            🖨 Imprimir / PDF
          </button>
        </div>
        <RelatorioExecutivo {...props} />
      </div>
    </Fragment>
  );
}
